import { preloadImages, preloadFonts } from './capabilities_v2_util';
import LocomotiveScroll from 'locomotive-scroll';

/**
 * selector
 */
$('.capabilities-v2--selector a').on('click', function(e) {

	e.preventDefault();

	$('.capabilities-v2--selector a').removeClass('active');
	$(this).addClass('active');

	var target = $(this).attr('href'),
		wrapperTarget = $(this).data('target');


	$('.capabilities-v2--item').hide();
	$(target).fadeIn()

	$('.tiles').hide();
	$('.tiles__line-img').attr('data-tiletype', wrapperTarget);

	var new_images = capabilities_images[wrapperTarget];
	var i;
	for (i in new_images) {
		$('.tile-counter--' + i + ' img').attr('src', new_images[i]['url'])
		if (new_images[i]['srcset']) {
			$('.tile-counter--' + i + ' img').attr('srcset', new_images[i]['srcset'])
		} else {
			$('.tile-counter--' + i + ' img').attr('srcset', '')
		}
	}

	setTimeout(function(){ 
		$('.tiles').fadeIn('slow');
	}, 500);
	

});

// Preload  images and fonts
Promise.all([preloadImages('.tiles__line-img')]).then(() => {
    // Remove loader (loading class)
    //document.body.classList.remove('loading');
    $('.tiles__wrap').removeClass('loading');


    if ($('.block.capabilities-v2').length > 0) {

	    // Initialize the Locomotive scroll
	    const scroll = new LocomotiveScroll({
	        el: document.querySelector('.scroll-wrapper'),
	        smooth: true,
	        getDirection:true
	    });

	    scroll.on('scroll', function(args) {
		   	const scroll_pos = args.scroll.y

		   	if (scroll_pos > 1) {
		   		$('body').addClass('shrink');
		   	} else {
		   		$('body').removeClass('shrink');
		   	}
		
	    });

	}

    
});